import { render } from "./DataPage.vue?vue&type=template&id=08b2b7fb&scoped=true"
import script from "./DataPage.vue?vue&type=script&lang=js"
export * from "./DataPage.vue?vue&type=script&lang=js"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b2b7fb"]])

export default __exports__